import React, { Component } from 'react'

import PropTypes from 'prop-types'

import * as bigMac from '../../../../assets/bigMacShutterStock.png'
import InfoButton from '../../../../components/ui/buttons/InfoButton'
import numberConverter from '../../../../utils/tuition/numberForCurrency'

export default class TotalCosts extends Component {
  static propTypes = {
    data: PropTypes.any,
  }

  static defaultProps = {
    data: {},
  }

  render() {
    const { data } = this.props
    return (
      <div style={{ marginTop: 10 }}>
        <div className="row" style={{ marginRight: -20 }}>
          <div className="col-lg-8">
            <table className="table table-striped text-center">
              <tbody>
                <tr>
                  <td>Total Investment:</td>
                  <td>${numberConverter(data.total_investment)}</td>
                </tr>
                <tr>
                  <td>Interest Paid:</td>
                  <td>${numberConverter(data.total_interest_paid_on_loan)}</td>
                </tr>
                <tr>
                  <td>Loan Amount: </td>
                  <td>${numberConverter(data.loan_amount)}</td>
                </tr>
                <tr>
                  <td>Interest Rate:</td>
                  <td>{(data.loan_rate * 100).toFixed(2)}%</td>
                </tr>
                <tr>
                  <td>Monthly Payment: </td>
                  {/*@TODO: bad math here*/}
                  <td>
                    {' '}
                    $
                    {numberConverter(
                      data.total_investment / 12 / data.loan_term,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className="col-md-4 p-0 d-none d-lg-block"
            style={{ overflow: 'hidden', marginRight: -5, marginTop: -10 }}
          >
            Same cost as:
            <span className="pull-right">
              <InfoButton
                content="Economists use the 'Big Mac Index' to compare local purchasing power."
                iconClass="fal fa-utensils-alt"
                styles={{ paddingRight: 10 }}
              />
            </span>
            <h1>
              {numberConverter(data.total_investment / 5.3)} Big
              <br />
              Macs
            </h1>
            <img
              style={{ maxHeight: 200, marginTop: -40 }}
              src={bigMac}
              alt="Burger Pie Chart for Tuition"
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/TotalCosts.js